module.exports = __webpack_public_path__ + "assets/img/td3.9b4225f9.png";